import { ApplicationRef, Injectable, OnDestroy } from '@angular/core';
import { SwUpdate, VersionEvent, VersionReadyEvent } from '@angular/service-worker';
import { Capacitor } from '@capacitor/core';
import { environment } from '@environment';
import { concat, interval, NEVER, Observable, Subject } from 'rxjs';
import { filter, first, map, takeUntil, tap } from 'rxjs/operators';
import { OverlayService } from './overlay/overlay.service';
/**
 * PwaUpdateService
 *
 * @description

 * @propertys
 */
@Injectable({
    providedIn: 'root',
})
export class PwaUpdateService implements OnDestroy {
    private checkInterval = 1000 * 60 * 60 * 6; // 6 小时
    private onDestroy = new Subject<void>();
    updateActivated: Observable<VersionEvent>;
    buildVersion: any;
    constructor(
        appRef: ApplicationRef,
        private swu: SwUpdate,
        private overlayService: OverlayService,
    ) {
        if (Capacitor.getPlatform() === 'web') {
            if (!swu.isEnabled) {
                this.updateActivated = NEVER.pipe(takeUntil(this.onDestroy));
                return;
            }
            const updatesAvailable = swu.versionUpdates.pipe(
                filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
                map((evt) => ({
                    type: 'UPDATE_AVAILABLE',
                    current: evt.currentVersion,
                    available: evt.latestVersion,
                })),
                tap(() => this.log('1:: UpdatesAvailable Checking for update...')),
            );

            const appIsStable = appRef.isStable.pipe(first((v) => v));
            concat(appIsStable, interval(this.checkInterval))
                .pipe(
                    tap(() => this.log('2:: appIsStable Checking for update...')),
                    takeUntil(this.onDestroy),
                )
                .subscribe(() => this.swu.checkForUpdate());

            updatesAvailable
                .pipe(
                    tap((evt) => this.log(`Update available: ${JSON.stringify(evt)}`)),
                    tap(() => {
                        this.log('3:: Update available: Checking for update...');
                        this.toastShow();
                    }),
                    takeUntil(this.onDestroy),
                )
                .subscribe(() => this.swu.activateUpdate());

            this.updateActivated = this.swu.versionUpdates.pipe(
                tap((evt) => this.log(`Update activated: ${JSON.stringify(evt)}`)),
                tap(() => this.log('4:: Update activated: Checking for update...')),
                takeUntil(this.onDestroy),
            );
        }
    }
    ngOnDestroy() {
        this.onDestroy.next();
    }
    private log(message: string) {
        const timestamp = new Date().toISOString();
        console.log(`[SwUpdates - ${timestamp}]: ${message}`);
    }

    private async toastShow() {
        this.buildVersion = environment.configApp.buildVersion;
        const toast = await this.overlayService.toast({
            message: `Atualizção disponível! Build ${this.buildVersion}  🎉`,
            // showCloseButton: true,
            position: 'top',
            buttons: [
                {
                    text: 'Recarregar',
                },
            ],
            // closeButtonText: `Recarrega!`
        });
        await toast.present();
        toast.onDidDismiss().then(() => window.location.reload());
        // .then(() => window.location.reload());
    }
}
